import React from 'react';
import PropTypes from 'prop-types';

import PanelMainMenu from './PanelMainMenu';

/**
 * Header menu entry point.
 * Does not load the CMS panel `menu` (that broke ja/ko and any locale without a translation).
 * Renders the same items as before via PanelMainMenu + i18n keys.
 */
function Menu({ closeMenu = null }) {
    return <PanelMainMenu closeMenu={closeMenu} />;
}

Menu.propTypes = {
    closeMenu: PropTypes.func,
};

export default Menu;
